import React from 'react';
import Select from 'react-select';

const CustomSelection = ({
  optionsList = [],
  onChange,
  value,
  placeholder = 'Select an option',
  defaultOpt = false,
  isDisabled = false,
  width = '250px'
}) => {
  const sortedOptions = [...optionsList].sort((a, b) =>
    (a.label || '').localeCompare(b.label || '')
  );

  const options = sortedOptions.map(opt => ({
    value: opt.name,
    label: opt.label,
    original: opt
  }));

  return (
    <div style={{ width }}>
      <Select
        isSearchable
        isClearable={defaultOpt}
        options={options}
        placeholder={placeholder}
        onChange={selected => {
          const value = selected ? selected.value : '';
          onChange({ target: { value } });
        }}
        value={
          value
            ? { value: value.name, label: value.label }
            : null
        }
        isDisabled={isDisabled}
      />
    </div>
  );
};

export default CustomSelection;
